module.exports = __webpack_public_path__ + "components/collaborations-header/static/header--small-14117e4ae41ebf1a22d733e41ea13c1d.jpg";